(function() {
  const PX_TO_CM = 2.54 / 96;
  const MAX_WIDTH_CM = 210;
  const MAX_HEIGHT_CM = 110;

  let MIN_HEIGHT_CM = 0;

  let desiredWidthCm = null;
  let desiredHeightCm = null;
  let lastEdited = null; // 'width' oder 'height'
  let updatingInputs = false;

  let svgEl = null;
  let rawWidthPx = null;
  let rawHeightPx = null;

  let currentOrientation = 'normal';

  let widthInput, heightInput, popularContainer;

  document.addEventListener('DOMContentLoaded', function() {
    svgEl = document.getElementById('svg-path');
    if (!svgEl) {
      console.warn('[Wunschtext] Kein SVG mit ID #svg-path gefunden.');
      return;
    }

    initRawSizeFromSvg();

    widthInput       = document.getElementById('target-width-cm');
    heightInput      = document.getElementById('target-height-cm');
    popularContainer = document.querySelector('.size_item-popular-sizes');

    initMinHeight();        // liest #min_height UND setzt Startwerte
    initSizeInputs();
    initSizeButtons();
    initColorControls();
    initOrientationControls();

    renderPreview();
    initPopularSizes();
    initPopularSizeClicks();
  });

  // ================= Helper =================

  function parseCmFromText(text) {
    if (!text) return null;
    const match = text.toString().replace(',', '.').match(/[\d.]+/);
    return match ? parseFloat(match[0]) : null;
  }

  function applyMinHeight(value) {
    if (value == null || !isFinite(value)) return null;
    if (MIN_HEIGHT_CM > 0 && value < MIN_HEIGHT_CM) return MIN_HEIGHT_CM;
    return value;
  }

  function forEachNode(selector, fn) {
    document.querySelectorAll(selector).forEach(fn);
  }

  // ================= Init: Min-Höhe & Startwerte =================

  function initMinHeight() {
    const minHeightInput = document.getElementById('min_height');
    if (minHeightInput && minHeightInput.value) {
      const parsed = parseCmFromText(minHeightInput.value);
      if (parsed && parsed > 0) MIN_HEIGHT_CM = parsed;
    }

    // min-Attribut nur für Höhe setzen
    if (MIN_HEIGHT_CM > 0 && heightInput) {
      heightInput.min = MIN_HEIGHT_CM.toFixed(1);
    }

    // NEU: wenn wir schon SVG-Masse haben, initiale Breite/Höhe
    if (MIN_HEIGHT_CM > 0 && rawWidthPx && rawHeightPx && widthInput && heightInput) {
      const rawWidthCm  = rawWidthPx  * PX_TO_CM;
      const rawHeightCm = rawHeightPx * PX_TO_CM;

      if (rawWidthCm > 0 && rawHeightCm > 0) {
        const aspect = rawWidthCm / rawHeightCm; // B/H
        const initH  = MIN_HEIGHT_CM;
        const initW  = aspect * initH;

        desiredWidthCm  = initW;
        desiredHeightCm = initH;
        lastEdited      = 'height';

        // Inputs & Anzeige direkt setzen
        updatingInputs      = true;
        widthInput.value    = initW.toFixed(1);
        heightInput.value   = initH.toFixed(1);
        updatingInputs      = false;

        const sizeInfo = document.getElementById('size-info');
        if (sizeInfo) {
          sizeInfo.textContent = initW.toFixed(1) + ' × ' + initH.toFixed(1) + ' cm';
        }
      }
    }
  }

  // ================= Rohgrösse SVG =================

  function initRawSizeFromSvg() {
    if (!svgEl) return;

    const vb = svgEl.viewBox && svgEl.viewBox.baseVal;
    if (vb && vb.width && vb.height) {
      rawWidthPx  = vb.width;
      rawHeightPx = vb.height;
      return;
    }

    try {
      const bb = svgEl.getBBox();
      if (bb && bb.width && bb.height) {
        rawWidthPx  = bb.width;
        rawHeightPx = bb.height;
        return;
      }
    } catch (e) {}

    const wAttr = parseFloat(svgEl.getAttribute('width') || '');
    const hAttr = parseFloat(svgEl.getAttribute('height') || '');
    if (wAttr && hAttr) {
      rawWidthPx  = wAttr;
      rawHeightPx = hAttr;
      return;
    }

    const cw = svgEl.clientWidth;
    const ch = svgEl.clientHeight;
    if (cw && ch) {
      rawWidthPx  = cw;
      rawHeightPx = ch;
      return;
    }

    rawWidthPx  = 100;
    rawHeightPx = 50;
  }

  // ================= Inputs (manuelle Eingabe) =================

  function initSizeInputs() {
    attachSizeHandler(widthInput,  'width');
    attachSizeHandler(heightInput, 'height');
  }

  function attachSizeHandler(input, kind) {
    if (!input) return;

    ['change', 'blur'].forEach(function(evt) {
      input.addEventListener(evt, function() {
        if (updatingInputs) return;

        let v = parseCmFromText(input.value);
        if (kind === 'height') {
          v = applyMinHeight(v);
        }

        if (v != null) {
          input.value = v.toFixed(1);
        }

        if (kind === 'width') {
          desiredWidthCm = v;
          lastEdited = 'width';
        } else {
          desiredHeightCm = v;
          lastEdited = 'height';
        }

        renderPreview();
      });
    });
  }

  // ================= Plus/Minus Buttons =================

  function initSizeButtons() {
    forEachNode('.size-step-btn', function(btn) {
      btn.addEventListener('click', function() {
        const targetKind = btn.dataset.target;
        const dir        = btn.dataset.dir === '-' ? -1 : 1;
        const input      = targetKind === 'width' ? widthInput : heightInput;
        if (!input) return;

        const step = parseFloat(input.step) || 0.1;
        let cur    = parseCmFromText(input.value);
        if (cur == null) cur = 0;

        cur += dir * step;

        if (input.min !== '') {
          const minAttr = parseFloat(input.min);
          if (!isNaN(minAttr)) cur = Math.max(cur, minAttr);
        }
        if (input.max !== '') {
          const maxAttr = parseFloat(input.max);
          if (!isNaN(maxAttr)) cur = Math.min(cur, maxAttr);
        }

        if (targetKind === 'height') {
          cur = applyMinHeight(cur);
        }

        input.value = cur.toFixed(1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // ================= Preview-Berechnung =================

  function renderPreview() {
    if (!rawWidthPx || !rawHeightPx) {
      updateSizeInfo(null, null);
      return;
    }

    const rawWidthCm  = rawWidthPx  * PX_TO_CM;
    const rawHeightCm = rawHeightPx * PX_TO_CM;

    if (!(rawWidthCm > 0 && rawHeightCm > 0)) {
      updateSizeInfo(null, null);
      return;
    }

    let scale = 1;

    if (lastEdited === 'width'  && desiredWidthCm  > 0) scale = desiredWidthCm  / rawWidthCm;
    if (lastEdited === 'height' && desiredHeightCm > 0) scale = desiredHeightCm / rawHeightCm;
    if (!lastEdited && desiredWidthCm  > 0)             scale = desiredWidthCm  / rawWidthCm;
    if (!lastEdited && !desiredWidthCm && desiredHeightCm > 0)
      scale = desiredHeightCm / rawHeightCm;

    if (!isFinite(scale) || scale <= 0) scale = 1;

    let tmpW = rawWidthCm  * scale;
    let tmpH = rawHeightCm * scale;

    // ✅ FIX: Mindesthöchi IMMER enforce (au wenn Breiti editiert wird)
    if (MIN_HEIGHT_CM > 0 && tmpH < MIN_HEIGHT_CM) {
      scale = MIN_HEIGHT_CM / rawHeightCm;
      tmpW  = rawWidthCm * scale;
      tmpH  = MIN_HEIGHT_CM;
    }

    if (tmpW > MAX_WIDTH_CM) {
      scale = MAX_WIDTH_CM / rawWidthCm;
      tmpW  = MAX_WIDTH_CM;
      tmpH  = rawHeightCm * scale;
    }
    if (tmpH > MAX_HEIGHT_CM) {
      scale = Math.min(scale, MAX_HEIGHT_CM / rawHeightCm);
      tmpW  = rawWidthCm * scale;
      tmpH  = rawHeightCm * scale;
    }

    if (!isFinite(scale) || scale <= 0) scale = 1;

    const finalWidthCm  = rawWidthCm  * scale;
    const finalHeightCm = rawHeightCm * scale;

    syncSizeInputs(finalWidthCm, finalHeightCm);
    updateSizeInfo(finalWidthCm, finalHeightCm);
  }

  function syncSizeInputs(wCm, hCm) {
    if (!widthInput || !heightInput || !wCm || !hCm) return;

    updatingInputs   = true;
    widthInput.value = wCm.toFixed(1);
    heightInput.value = hCm.toFixed(1);
    desiredWidthCm   = wCm;
    desiredHeightCm  = hCm;
    updatingInputs   = false;
  }

  function updateSizeInfo(wCm, hCm) {
    const el = document.getElementById('size-info');
    if (!el || !wCm || !hCm) {
      if (el) el.textContent = '–';
      return;
    }
    el.textContent = wCm.toFixed(1) + ' × ' + hCm.toFixed(1) + ' cm';
  }

  // ================= Beliebte Grössen =================

  function initPopularSizes() {
    if (!popularContainer) return;

    const style = window.getComputedStyle(popularContainer);
    if (style.display === 'none' || style.visibility === 'hidden') return;

    if (!rawWidthPx || !rawHeightPx) initRawSizeFromSvg();
    if (!rawWidthPx || !rawHeightPx) return;

    const rawWidthCm  = rawWidthPx  * PX_TO_CM;
    const rawHeightCm = rawHeightPx * PX_TO_CM;
    if (!rawWidthCm || !rawHeightCm) return;

    const aspect = rawWidthCm / rawHeightCm;
    if (!isFinite(aspect) || aspect <= 0) return;

    let minH = MIN_HEIGHT_CM;
    if (!minH || !isFinite(minH) || minH <= 0) minH = 10;

    const minWidthCm = aspect * minH;

    let baseWidth = Math.ceil(minWidthCm / 10) * 10;
    if (baseWidth < minWidthCm) baseWidth += 10;

    const widths = [baseWidth, baseWidth + 20, baseWidth + 40];

    const spans = popularContainer.querySelectorAll('.poular-size_item span');
    widths.forEach(function(w, idx) {
      if (!spans[idx]) return;
      const h = w / aspect;
      spans[idx].textContent = w.toFixed(0) + ' cm x ' + h.toFixed(2) + ' cm';
    });
  }

  function initPopularSizeClicks() {
    if (!widthInput || !heightInput || !popularContainer) return;

    const items = popularContainer.querySelectorAll('.poular-size_item');
    if (!items.length) return;

    items.forEach(function(item) {
      item.addEventListener('click', function() {
        const span = item.querySelector('span');
        if (!span || !span.textContent) return;

        const txt   = span.textContent;
        const match = txt.match(/([\d.,]+)\s*cm\s*x\s*([\d.,]+)/i);
        if (!match) return;

        let w = parseFloat(match[1].replace(',', '.'));
        let h = parseFloat(match[2].replace(',', '.'));
        if (!isFinite(w) || !isFinite(h)) return;

        h = applyMinHeight(h);

        widthInput.value  = w.toFixed(1);
        heightInput.value = h.toFixed(1);

        desiredWidthCm  = w;
        desiredHeightCm = h;
        lastEdited      = 'width';

        widthInput.dispatchEvent(new Event('change', { bubbles: true }));
        heightInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // ================= Farbe & Ausrichtung =================

  function initColorControls() {
    const colorInput =
      document.querySelector('.wunschtext-color-input') ||
      document.querySelector('.wunschtext-line-color-input');

    if (!colorInput) return;

    // 🎯 Farbe immer aus dem Attribut `color-value` holen (Fallback auf value / schwarz)
    const initialColor =
      colorInput.getAttribute('color-value') ||
      colorInput.value ||
      '#000000';

    applyColorToSvg(initialColor);

    colorInput.addEventListener('change', function(e) {
      const target = e.target;

      const newColor =
        target.getAttribute('color-value') ||
        target.value ||
        '#000000';

      applyColorToSvg(newColor);
    });
  }

  // Wichtig: nur diese Funktion ist für die Farbe zuständig
  function applyColorToSvg(color) {
    if (!svgEl || !color) return;

    // ALLE Shapes im #svg-path einfärben – egal welche Klasse
    const targets = svgEl.querySelectorAll(
      'path, rect, circle, ellipse, polygon, polyline, text'
    );

    targets.forEach(function(node) {
      // alte Inline-Fills entfernen
      if (node.style) {
        node.style.removeProperty('fill');
      }
      if (node.hasAttribute('fill')) {
        node.removeAttribute('fill');
      }

      // neues fill setzen
      node.setAttribute('fill', color);

      // zusätzlich als Inline-Style mit !important,
      // damit CSS-Klassen im <style> nicht drüberfahren
      if (node.style) {
        node.style.setProperty('fill', color, 'important');
      }
    });
  }

  function initOrientationControls() {
    const radios = document.querySelectorAll('.ausrichtung__input');
    if (!radios.length || !svgEl) return;

    radios.forEach(function(radio) {
      if (radio.checked) {
        currentOrientation = radio.value === 'gespiegelt' ? 'gespiegelt' : 'normal';
      }
      radio.addEventListener('change', function() {
        if (!radio.checked) return;
        currentOrientation = radio.value === 'gespiegelt' ? 'gespiegelt' : 'normal';
        applyOrientation();
      });
    });

    applyOrientation();
  }

  function applyOrientation() {
    if (!svgEl) return;

    if (currentOrientation === 'gespiegelt') {
      svgEl.style.transform       = 'scaleX(-1)';
      svgEl.style.transformOrigin = '50% 50%';
    } else {
      svgEl.style.transform       = 'none';
      svgEl.style.transformOrigin = '';
    }
  }
})();
